<template>
  <div class="wrapper">
    <div
      class="header"
      style="display: none"
    >
      <!-- 登录 -->
      <span
        title="登录"
        class="nav-iconSet-login"
        v-show="hasUserInfo"
        @click="signout"
      >安全退出</span>
    </div>
    <div class="content-wrapper">
      <router-view />
    </div>
  </div>
</template>
<script>
import { removeToken, getToken } from "../utils/auth";
import decodeTicket from "../utils/decodeTicket";
// import { background } from "@/layout/Background";
export default {
  computed: {
    backgroundAuto() {
      let fixedList = ["Tourist", "Visitor", "Teacher"];
      return fixedList.includes(this.$route.name);
    },
    // 是否登录
    hasUserInfo() {
      return getToken();
      // return Object.keys(this.userInfo).length > 1;
    },
  },
  created() {
    decodeTicket();
    //this.handleGetCodeAndState();
  },
  destroyed() {
    removeToken();
  },
  methods: {
    // 获取用户登录状态
    handleGetCodeAndState() {
      // if (!decodeTicket()) {
      //   this.$router.push("/SignIn");
      // } else {
      //   if (getToken()) {
      //     // this.$router.push({ name: "sysAd" });
      //     // this.$router.push({ name: "application" });
      //     // this.$router.push({ name: "weblication" });
      //   } else {
      //     this.$router.push("/SignIn");
      //   }
      // }
    },
    signout() {
      removeToken();
      //window.location.href = `${process.env.VUE_APP_CAS_URL}logout?service=${process.env.VUE_APP_URL}`;
    },
  },
};
</script>
<style lang="scss">
.header {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 10;
  height: 50px;
  padding-right: 50px;
  padding-left: 50px;
  line-height: 50px;
  text-align: right;
}

.nav-iconSet-login {
  color: #333;
  cursor: pointer;
}
.wrapper{
  height: 100%;
}
.content-wrapper {
  position: relative;
  height: 100%;
  overflow-y: auto;
}
</style>
